module.exports = __webpack_public_path__ + "static/media/noble-match-text.21d90177.svg";